__turbopack_context__.v({
  "branch": "ProductCard-module-scss-module___HK1Jq__branch",
  "card": "ProductCard-module-scss-module___HK1Jq__card",
  "details": "ProductCard-module-scss-module___HK1Jq__details",
  "detailsItem": "ProductCard-module-scss-module___HK1Jq__detailsItem",
  "fade-in": "ProductCard-module-scss-module___HK1Jq__fade-in",
  "floatingAction": "ProductCard-module-scss-module___HK1Jq__floatingAction",
  "footer": "ProductCard-module-scss-module___HK1Jq__footer",
  "footerLogo": "ProductCard-module-scss-module___HK1Jq__footerLogo",
  "footerMain": "ProductCard-module-scss-module___HK1Jq__footerMain",
  "image": "ProductCard-module-scss-module___HK1Jq__image",
  "imageBlur": "ProductCard-module-scss-module___HK1Jq__imageBlur",
  "imageWrapper": "ProductCard-module-scss-module___HK1Jq__imageWrapper",
  "link": "ProductCard-module-scss-module___HK1Jq__link",
  "location": "ProductCard-module-scss-module___HK1Jq__location",
  "meta": "ProductCard-module-scss-module___HK1Jq__meta",
  "no-transform": "ProductCard-module-scss-module___HK1Jq__no-transform",
  "otherPrice": "ProductCard-module-scss-module___HK1Jq__otherPrice",
  "otherPriceLabel": "ProductCard-module-scss-module___HK1Jq__otherPriceLabel",
  "otherPriceValue": "ProductCard-module-scss-module___HK1Jq__otherPriceValue",
  "otherPrices": "ProductCard-module-scss-module___HK1Jq__otherPrices",
  "price": "ProductCard-module-scss-module___HK1Jq__price",
  "priceLabel": "ProductCard-module-scss-module___HK1Jq__priceLabel",
  "priceValue": "ProductCard-module-scss-module___HK1Jq__priceValue",
  "retailer": "ProductCard-module-scss-module___HK1Jq__retailer",
  "rotate": "ProductCard-module-scss-module___HK1Jq__rotate",
  "statuses": "ProductCard-module-scss-module___HK1Jq__statuses",
  "subTitle": "ProductCard-module-scss-module___HK1Jq__subTitle",
  "title": "ProductCard-module-scss-module___HK1Jq__title",
});
